module.exports = __webpack_public_path__ + "static/media/feed_ui.fe4ac7e4.png";